import React, { Suspense } from "react";

import { Layout } from "@/components/ui";
import LinkFooter from "@/features/ui/components/link-footer";
import {
  NewGroupPanel,
  SuggestedGroupsPanel,
} from "@/features/ui/util/async-components";

interface GroupsPageProps {
  children: React.ReactNode;
}

/** Page to display groups. */
const GroupsPendingPage: React.FC<GroupsPageProps> = ({ children }) => (
  <>
    <Layout.Main>{children}</Layout.Main>

    <Layout.Aside>
      <Suspense fallback={null}>
        <NewGroupPanel key="new-group-panel" />
      </Suspense>

      <Suspense fallback={null}>
        <SuggestedGroupsPanel key="suggested-groups-panel" />
      </Suspense>

      <LinkFooter key="link-footer" />
    </Layout.Aside>
  </>
);

export default GroupsPendingPage;
